import React, { Component } from "react";
import { message, Modal, List, Row, Col, Typography, Space, Button } from "antd";
import { IconEye } from '../../Widgets/Iconos'
import { Link } from 'react-router-dom';
import axios from "axios";
import moment from "moment";


const { Text } = Typography;

class ModalClientesTipo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            type: props.type ?? 1,
            customers: [],
        }
    }

    getCustomers = () => {
        this.setState({ loading: true })
        axios.get('/analytics-type', {
            params: {
                filters: this.props.filters,
                type: this.state.type
            }
        }).then((response) => {
            console.log('customers', response)
            this.setState({ customers: response.data, loading: false })
        }).catch(error => {
            message.error('Error getting the customers')
            console.log(error)
        }).finally(() => this.setState({ loading: false }))
    }

    componentDidMount() {
        this.getCustomers()
    }

    render() {
        return (
            <List
                className='components-list'
                itemLayout="horizontal"
                loading={this.state.loading}
                dataSource={this.state?.customers}
                header={<Row style={{ width: "100%" }}>


                    <Col xs={5} className="center" >
                        <Text ellipsis strong>Name</Text>
                    </Col>
                    <Col xs={5} className="center" >
                        <Text ellipsis >Email</Text>
                    </Col>
                    <Col xs={5} className="center" >
                        <Text ellipsis >Phone Number</Text>
                    </Col>
                    <Col xs={3} className="center" >
                        <Text ellipsis >Pairs</Text>
                    </Col>

                    <Col xs={4} className="center" >
                        <Text ellipsis >Register Date</Text>
                    </Col>

                </Row>}
                renderItem={item => (
                    <List.Item className='component-list-item' >

                        <Row style={{ width: "100%" }}>


                            <Col xs={5} className="center" >
                                <Text ellipsis strong>{item.cliente.nombre} {item.cliente.apellidos}</Text>
                            </Col>
                            <Col xs={5} className="center" >
                                <Text ellipsis >{item.cliente.email}</Text>
                            </Col>
                            <Col xs={5} className="center" >
                                <Text ellipsis >{item.cliente.telefono ?? "-"}</Text>
                            </Col>
                            <Col xs={3} className="center" >
                                <Text ellipsis >{item.pairs ?? "-"} Pair(s)</Text>
                            </Col>

                            <Col xs={4} className="center" >
                                <Text ellipsis >{moment(item.cliente.createdAt).format("MM/DD/YYYY")}</Text>
                            </Col>
                            <Col xs={2} className="center" >
                                <Space wrap>

                                    <Link to={`/admin/crm/clientes/detalle/${item.cliente_id}`} >
                                        <Button type='primary'
                                            disabled={false}
                                            className='btn-primary' icon={<IconEye />} />
                                    </Link>

                                </Space>
                            </Col>
                        </Row>


                    </List.Item>
                )}
            />
        )
    }


}

export default function clientesTipo(props) {
    const { visible = false, onClose = () => { }, type, filters } = props

    return <Modal
        open={visible}
        onCancel={onClose}
        title={type === 1 ? "Pickup & Delivery" : "In store"}
        destroyOnClose={true}
        footer={[
            <Button key="back" onClick={onClose}>
                Return
            </Button>,
        ]}

        width={'80%'}
    >
        <ModalClientesTipo {...props} />
    </Modal>

}